/**
 * VI-717: JobTarget-blue header rendered inside JTScreener for jobseeker pages.
 * Not interactive — a purely branded banner.
 */
const JobseekerHeader = () => {
  return (
    <header className="jobseeker-header" role="banner">
      <img className="jobseeker-header__logo" src="/images/JobTarget_logo.svg" alt="JobTarget" draggable="false"/>
    </header>
  );
};

export default JobseekerHeader;
